/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_Works_1Inputs */

const en_vc_status_works_1 = /** @type {(inputs: Vc_Status_Works_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drawing and path tools, Pathfinder and Shape Builder`)
};

const zh_vc_status_works_1 = /** @type {(inputs: Vc_Status_Works_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绘图与路径工具、路径查找器和形状生成器`)
};

/**
* | output |
* | --- |
* | "Drawing and path tools, Pathfinder and Shape Builder" |
*
* @param {Vc_Status_Works_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_works_1 = /** @type {((inputs?: Vc_Status_Works_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_Works_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_works_1(inputs)
	return zh_vc_status_works_1(inputs)
});
export { vc_status_works_1 as "vc.status.works.1" }